import React from 'react'
import { Webinars, SEO } from 'newComponents'
import Layout from '../components/layout'

const WebinarsNew = () => (
  <Layout>
    <SEO
      title="Webinars"
      description="Learn more about and sign up for our latest webinars here. Missed a live session? Listen to the on-demand recording."
    />
    <Webinars />
  </Layout>
)

export default WebinarsNew
